import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../utils/apiUrl';
import './ClubhouseAuth.css';

export const ClubhouseForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await axios.post(`${API_URL}/api/clubhouse/auth/forgot-password`, {
        email: email.trim().toLowerCase()
      });
      setSubmitted(true);
    } catch (err) {
      // Even on error, show success to prevent email enumeration
      // Only show error for network issues
      if (!err.response) {
        setError('Unable to connect. Please check your internet connection.');
      } else {
        setSubmitted(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="clubhouse-auth-page">
      <div className="auth-container">
        <div className="auth-card">
          {!submitted ? (
            <>
              <div className="auth-header">
                <h1>Forgot Password?</h1>
                <p>Enter your email and we&apos;ll send you a reset link</p>
              </div>

              {error && (
                <div className="error-message">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="form-input"
                    placeholder="you@example.com"
                    autoFocus
                  />
                </div>

                <button 
                  type="submit" 
                  className="btn-primary btn-large"
                  disabled={loading || !email.trim()}
                >
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <div className="auth-footer">
                <p>
                  Remember your password? <Link to="/clubhouse/login">Sign In</Link>
                </p>
              </div>
            </>
          ) : (
            <div className="success-state">
              <div className="success-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 2L11 13" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 2L15 22L11 13L2 9L22 2Z" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h2>Check Your Email</h2>
              <p className="success-message">
                If an account exists for <strong>{email}</strong>, we sent a password reset link.
              </p>
              <p className="success-hint">
                The link will expire in 60 minutes. Check your spam folder if you don&apos;t see it.
              </p>
              <div className="success-actions">
                <Link to="/clubhouse/login" className="btn-primary btn-large">
                  Back to Login
                </Link>
                <button 
                  type="button"
                  className="btn-text"
                  onClick={() => {
                    setSubmitted(false);
                    setEmail('');
                  }}
                >
                  Try a different email
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
